<template>
	<div class="main">
		<!-- <section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4"></div>
							<div class="col-md-4"></div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-4 "></div>
						<div class="col-md-4 ">
							<div class="col-xs-offset-5 col-xs-5 col-md-offset-4 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
						<div class="col-md-4 "></div>
					</div>
				</div>
			</div>
		</section> -->
		<div class="tab-content">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row form-group">
					<div class="col-md-12 text-right form-inline" >
						<a href="javascript:;" class="btn btn-danger m-xs" v-if="isAdmin('stay')" @click="showPopupControl(true)">物品清單</a>
						<a href="javascript:;" class="btn btn-danger m-xs" @click="gotoView('stay.borrowApply')" v-if="sessionData.accountType == 'STU'">物品借用申請單</a>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 form-group">
						<table class="table table-no-more table-bordered table-striped mb-none" style="width:100% !important;">
							<thead>
								<tr>
									<th class="text-center" style="width:5%">學期</th>
									<th class="text-center" style="width:16%">系科年級</th>
									<th class="text-center" style="width:8%">學號</th>
									<th class="text-center" style="width:8%">姓名</th>
									<th class="text-center" style="width:8%">宿舍</th>
									<th class="text-center" style="width:8%">房號-床位</th>
									<th class="text-center" style="width:10%">借用物品</th>
									<th class="text-center" style="width:5%">數量</th>
									<th class="text-center" style="width:10%">借用日期</th>
									<th class="text-center" style="width:10%">申請狀態</th>
									<th class="text-center" style="width:10%">歸還日期</th>
								</tr>
							</thead>
							<tbody v-for="(item, index) in resBorrowGrid.rows" :key="index">
								<tr>
									<td class="text-center" data-title="學期">{{item.smtr}}</td>
									<td class="text-center" data-title="系科年級">{{item.deptCodeStr}}<br/>{{item.drade}}年{{item.dradeClass}}班</td>
									<td class="text-center" data-title="學號">{{item.account}}</td>
									<td class="text-center" data-title="姓名">{{item.name}}</td>
									<td class="text-center" data-title="宿舍" >{{item.bedFloor}}</td>
									<td class="text-center" data-title="房號-床位" >{{item.bedRoom}}-{{item.bed}}</td>
									<td class="text-center" data-title="借用物品" >{{item.resName}}</td>
									<td class="text-center" data-title="數量" >{{item.borrowNum}}</td>
									<td class="text-center" data-title="借用日期" >{{item.borrowDate ? customFormatter(item.borrowDate):""}}</td>
									<td class="text-center" data-title="申請狀態" >
										<span v-if="!isAdmin('stay')">{{item.applyStatusStr}}</span>
										<a v-else href="javascript:;" class="btn btn-link" @click="gotoView('stay.borrowApply', {sno:item.sno, account:item.account, smtr:item.smtr})">{{item.applyStatusStr}}</a>
									</td>
									<td class="text-center" data-title="歸還日期">
										<!-- <a href="javascript:;" class="btn btn-link" v-if="item.applyStatus == 'Y'" @click="item.applyStatus = 'R'; checkResBorrow(item)">歸還</a> -->
										<span v-if="item.applyStatus == 'R'">{{item.escheatDate ? customFormatter(item.escheatDate):""}}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center">
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<resPopup v-if="isShowPopup" />
	</div>
</template>
<script>
import resPopup from "./resPopup";
export default {
	components:{
		resPopup
	},
	data(){
		return{
			smtr:"",
			resBorrowGrid:{},
			isShowPopup:false,
			page: 1,
			pageSize:10,
			totalPage:0
		}
	},
	mounted(){
		this.gridInit();
	},
	methods:{
		gridInit(){
			let param = {
				model:{},
				page: this.page,
				pageSize: this.pageSize
			};
			if(this.sessionData.accountType == "STU"){
				param.model["account"] = this.sessionData.account;
			}
			const api = "/api/ResBorrom/resBorrowList/";
			this.$axios.post(api, JSON.stringify(param)).then(resp => {
				this.resBorrowGrid = resp.data.data;
				this.totalPage = this.resBorrowGrid.total;
			});
		},
		selectYear(){
			let smtrArray = [];
			let nowYear = (new Date().getFullYear() - 1911);
			let nowMonth = new Date().getMonth() + 1;
			if(nowMonth < 8){
				nowYear = nowYear-1;
			}
			for(let y = nowYear; y > 100 ; y--){
				if((y == nowYear && nowMonth < 8) || y < nowYear){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
				}
				smtrArray.push({text:y+"年第一學期",value:y+"1"});
			}
			return smtrArray;
		},
		updateGrid(page){
			this.page = page;
			this.gridInit();
		},
		showPopupControl(isShowPopup){
			this.isShowPopup = isShowPopup;
		},
		checkResBorrow(item){
			let _this = this;
			const api = "/api/ResBorrom/checkResBorromApply/";
			this.$axios.post(api, item).then(resp =>{
				bootbox.alert(resp.data.msg, function(){
					if (resp.data.status === "success") {
						_this.updateGrid();
					}
				});
			});
		},
	}
}
</script>